import { render, staticRenderFns } from "./WhitelabelFooter.vue?vue&type=template&id=240bea22&scoped=true&"
import script from "./WhitelabelFooter.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelFooter.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelFooter.vue?vue&type=style&index=0&id=240bea22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240bea22",
  null
  
)

export default component.exports